export enum Delete {
  DeleteTag = 'DeleteTag',
  DeleteCompanyLocation = 'DeleteCompanyLocation',
  DeleteDepartment = 'DeleteDepartment',
  DeleteSubDepartment = 'DeleteSubDepartment',
  DeleteMatchComment = 'DeleteMatchComment',
  DeleteSurvey = 'DeleteSurvey',
  DeleteScreeningApplicant = 'DeleteScreeningApplicant',
  DeleteApplicantDocument = 'DeleteApplicantDocument',
  DeleteDepartmentTargetProfile = 'DeleteDepartmentTargetProfile',
  RemoveDepartmentTargetProfileSkill = 'RemoveDepartmentTargetProfileSkill',
}
